/**
 * Gallery-image adapter for CodeStitch mosaic galleries (`div.cs-image-group`).
 *
 * Items are `picture.cs-picture` pinned to explicit grid cells by an ordinal
 * class `cs-picture1…N`. Same pinning problem as card grids: `postMoveNormalize`
 * renumbers `cs-pictureN` to DOM order after every move (no-op for a uniform,
 * non-pinned gallery). `reorderAxis:'grid'` uses 2D nearest-cell hit-testing.
 */

import { moveSiblingPreservingEids } from '../element-insert.js';
import { normalizeOrdinalClasses } from '../ordinal-normalize.js';

export const galleryImageAdapter = {
  kind: 'gallery-image',
  label: 'Gallery image',
  itemSelector: '.cs-picture',
  parentSelector: '.cs-image-group',
  reorderSelector: '.cs-image-group > picture.cs-picture',
  reorderSiblingSelector: '.cs-image-group > picture.cs-picture',
  reorderAxis: 'grid',
  historyLabel: 'Reorder gallery image',
  toastText: 'Gallery image reordered',
  vtPrefix: 'pb-gal-',
  vtSelector: '.cs-image-group > picture.cs-picture',
  moveFn: moveSiblingPreservingEids,
  postMoveNormalize(sectionHtml, ctx) {
    return normalizeOrdinalClasses(sectionHtml, {
      anchorEid: ctx?.sourceEid,
      parentSelector: ctx?.parentSelector || '.cs-image-group',
      ordinalPrefix: 'picture',
      normalizeAll: ctx?.normalizeAll === true
    });
  },
  menuActions: ['duplicate', 'delete'],
  postInsertFlow: null,
  cssPatch: null,
  reorderable: true,

  match(probe) {
    if (!probe || typeof probe.closest !== 'function') return null;
    if (!probe.closest('.cs-image-group')) return null;
    return probe.closest('.cs-picture');
  }
};
